export default "__VITE_ASSET__BPYvPCPi__$_?react__"